import * as React from 'react';
export var FormItemContext = React.createContext({
    status: 'default'
});
